"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LivejournalIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("../../SvgIcon"));

var _ref = /*#__PURE__*/_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.662 13.018a8.415 8.415 0 0 1 4.343-4.369h.001L6.19 1.843l-.003-.001a8.407 8.407 0 0 0-4.344 4.37l6.82 6.806h-.001zm4.831-2.044a4.894 4.894 0 0 0-2.523 2.537l3.184.659-.66-3.196h-.001z",
  fill: "#13374d"
}), _react.default.createElement("path", {
  d: "M13.493 10.975l-.487-2.325h-.002a8.417 8.417 0 0 0-4.342 4.368l2.308.493a4.916 4.916 0 0 1 2.523-2.536",
  fill: "#fff"
}));

function LivejournalIcon(props) {
  var color = props.color;
  return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 18 18"
  }, props), _react.default.createElement("path", {
    d: "M1.844 6.21L0 4.369A8.405 8.405 0 0 1 4.347 0l1.841 1.839.001.001a8.384 8.384 0 1 1-5.056 7.695 8.275 8.275 0 0 1 .71-3.323l6.82 6.806h-.001a8.415 8.415 0 0 1 4.343-4.369h.001L6.19 1.843l-.003-.001a8.407 8.407 0 0 0-4.343 4.369zm11.649 4.764a4.894 4.894 0 0 0-2.523 2.537l3.184.659-.66-3.196h-.001z",
    fill: color || '#00afed'
  }), !color && _ref);
}

LivejournalIcon.displayName = 'LivejournalIcon';
LivejournalIcon.defaultProps = {
  color: null
};
LivejournalIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes.default.string
} : {};